export default "__VITE_ASSET__DHXJjYbK__"